/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Employeepost202,
  PostApiV1Employeepost400,
  PostApiV1Employeepost401,
  PostApiV1Employeepost409,
  PostApiV1Employeepost500,
  PostApiV1EmployeepostMutationRequest,
  PostApiV1EmployeepostMutationResponse,
} from "../../types/employeePostController/PostApiV1Employeepost.ts";
import { createEmployeePostRequestViewModelSchema } from "../createEmployeePostRequestViewModelSchema.ts";
import { employeePostViewModelSchema } from "../employeePostViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Employeepost202Schema = z.lazy(
  () => employeePostViewModelSchema,
) as unknown as ToZod<PostApiV1Employeepost202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Employeepost400Schema =
  z.any() as unknown as ToZod<PostApiV1Employeepost400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Employeepost401Schema =
  z.any() as unknown as ToZod<PostApiV1Employeepost401>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1Employeepost409Schema =
  z.any() as unknown as ToZod<PostApiV1Employeepost409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Employeepost500Schema =
  z.any() as unknown as ToZod<PostApiV1Employeepost500>;

export const postApiV1EmployeepostMutationRequestSchema = z.lazy(
  () => createEmployeePostRequestViewModelSchema,
) as unknown as ToZod<PostApiV1EmployeepostMutationRequest>;

export const postApiV1EmployeepostMutationResponseSchema = z.lazy(
  () => postApiV1Employeepost202Schema,
) as unknown as ToZod<PostApiV1EmployeepostMutationResponse>;
